import { UserRole } from '../../components/common/header/photo/head-bar/newsComponent/utils/userRoleHelper';
import { Translate } from '../../shared/LanguageService';
import { NewsItemPayload, RecipientPayload } from './NewsApi';
import type { INewsItem } from './NewsItem';
import { formatDate } from '../../shared/LanguageService';

// Keep in sync with backend: SE360.Api/Features/Views/News/Models/NewsItemStatus.cs
export enum NewsItemStatus {
    Draft = 0,
    Active = 1,
    Archived = 2
}

export const roleLabels: Partial<Record<UserRole, string>> = {
    [UserRole.Admin]: 'role/administrator',
    [UserRole.BrokerAgent]: 'role/broker-agent',
    [UserRole.Photographer]: 'role/photographer',
    [UserRole.PhotoEditor]: 'role/image-editor',
    [UserRole.PlanEditor]: 'role/plan-editor'
};

export const getRoleLabel = (role: UserRole | string): string => {
    const key = roleLabels[role as UserRole];
    return key ? Translate(key) : Translate('common/unknown-role');
};

export function getRoleOptions() {
    return Object.keys(roleLabels).map((roleKey) => ({
        value: roleKey as UserRole,
        label: Translate(roleLabels[roleKey as UserRole]!)
    }));
}

export const formatSafe = (value?: string) => {
    if (!value) return '–';
    try {
        return formatDate(new Date(value), 'yyyy-MM-dd');
    } catch {
        return '–';
    }
};

export function transformToPayload(
    item: INewsItem,
    brokerChainIds: number[] = []
): NewsItemPayload {
    const recipients: RecipientPayload[] = [];

    for (const recipient of item.recipients) {
        const roleValue = recipient.role.trim();
        if (!roleValue) continue;

        if (roleValue === UserRole.BrokerAgent && brokerChainIds.length > 0) {
            for (const chainId of brokerChainIds) {
                recipients.push({ role: roleValue, brokerChainId: chainId });
            }
        } else {
            recipients.push({
                role: roleValue,
                brokerChainId: recipient ? recipient.brokerChainId : null
            });
        }
    }

    const payload: Omit<NewsItemPayload, 'id'> & { id?: number } = {
        visible: item.visible,
        status: item.status,
        content: item.content,
        endDate: item.endDate,
        title: item.title,
        startDate: item.startDate,
        visibleDate: item.visibleDate,
        recipients
    };

    if (typeof item.id === 'number' && item.id > 0) {
        payload.id = item.id;
    }

    return payload as NewsItemPayload;
}
